var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"offer_list-container"},_vm._l((_vm.featuredOffers),function(offer){return _c('SingleOffer',{attrs:{"offer":offer}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }